export const ACADEMIC = {
  name: 'Academic illustrations',
  description: ['You can still find scientific papers published with images made from Word shapes. It\'s not just about aesthetics, a well-design illustration gets more attention which improves understanding.'],
  photos: [
    { uri: '/academic/brain.png', title: 'Bissected brain', imageHeight: 300 },
    { uri: '/academic/marmoset.png', title: 'Marmoset', imageHeight: 300 },
    { uri: '/academic/mouse.png', title: 'Mouse cortex', imageHeight: 300 },
    { uri: '/academic/fxd.png', title: 'Explaining Fragile X', imageHeight: 300 },
  ],
  component: 'grid',
  styles: { groupPadding: 2 },
}